/**
 * The two `EvidenceAnswerPorts` members only Chat may name (ruling 62), filled
 * into the app-shell host's slot at module scope.
 *
 * `src/composition/hosts/evidence/integrationPartners.ts` reads the query
 * cache during render. `SourceCardActions` stays inside the Chat globs, so
 * this Chat file is still the one that fills the slot.
 */

import { registerEvidenceAnswerChatPorts } from '@/composition/hosts/evidence-answer-chat-ports';

import { getPartnerConfig } from '@/composition/hosts/evidence/integrationPartners';
import { SourceCardActions } from './SourceCardActions';

registerEvidenceAnswerChatPorts({
  getPartnerConfig,
  sourceActionsComponent: SourceCardActions,
});
